module.exports = __webpack_public_path__ + "assets/da31102a1c8c7edfd3e732a89ae42876.png";